module.exports = __webpack_public_path__ + "img/banner_betconnect.881a564f.jpg";